"use strict";
exports.__esModule = true;
var Types_1 = require("../Types");
var Constants_1 = require("../Constants");
var Version_1 = require("../Version");
var Environment_1 = require("./upload/Environment");
var TelemetryProviders_1 = require("./TelemetryProviders");
var Logging_1 = require("../Logging");
var GamingTelemetryProvider = (function () {
    function GamingTelemetryProvider(registrationOptions, optionalDataConsentCallback) {
        var _this = this;
        this.WriteSessionStart = function (commonProperties, eventProperties, customAttributes) {
            var sessionStartPayload = { customAttributes: customAttributes };
            _this.providers.DoublePump.AsCriticalOptional(commonProperties, eventProperties, eventProperties, sessionStartPayload);
        };
        this.WriteSessionStop = function (commonProperties, eventProperties, sessionStopPayload) {
            _this.providers.DoublePump.AsCriticalOptional(commonProperties, eventProperties, eventProperties, sessionStopPayload);
        };
        this.providerLogger = new Logging_1.LogProvider("Provider");
        this.providers = new TelemetryProviders_1.TelemetryProviders(this.providerLogger, registrationOptions, optionalDataConsentCallback);
    }
    GamingTelemetryProvider.RegisterProvider = function (commonProperties, registrationOptions, optionalDataConsentCallback) {
        var newProvider = new this(registrationOptions, optionalDataConsentCallback);
        var Env = "Unknown";
        switch (Environment_1.getEnvironment()) {
            case Environment_1.EnvironmentValue.ReactNativeMobile:
                Env = "ReactNativeMobile";
                break;
            case Environment_1.EnvironmentValue.ReactNativeWindows:
                Env = "ReactNativeWindows";
                break;
            case Environment_1.EnvironmentValue.WWA:
                Env = "WWA";
                break;
            case Environment_1.EnvironmentValue.NodeJs:
                Env = "NodeJS";
                break;
            case Environment_1.EnvironmentValue.Browser:
                Env = "Browser";
                break;
        }
        newProvider.providers.Critical.WriteRequired(commonProperties, {
            eventName: "ProviderRegistered"
        }, { gtl: { semVer: Version_1.LIB_VERSION, env: Env } });
        return newProvider;
    };
    GamingTelemetryProvider.prototype.UnregisterProvider = function (commonProperties) {
        this.providers.Critical.WriteOptional(commonProperties, {
            eventName: "ProviderUnregistered"
        }, {});
        this.providers.Unregister();
    };
    GamingTelemetryProvider.prototype.WriteError = function (commonProperties, eventProperties, isCritical, errorPayload) {
        if (!isCritical) {
            this.providers.Component.Write(commonProperties, eventProperties, errorPayload);
        }
        else {
            this.providers.DoublePump.AsCriticalRequired(commonProperties, eventProperties, eventProperties, errorPayload);
        }
    };
    GamingTelemetryProvider.prototype.WriteCriticalError = function (commonProperties, errorPayload) {
        this.providers.Critical.WriteRequired(commonProperties, {
            eventName: Types_1.GtlEventType.Error
        }, errorPayload);
    };
    GamingTelemetryProvider.prototype.WritePageView = function (commonProperties, eventProperties, pageName, pageImpressionContext, pageViewData, referrerUri, data) {
        this.providers.Component.WriteWithPartB(commonProperties, eventProperties, data, "PageViewData", {
            id: pageImpressionContext.impressionId,
            name: pageName,
            pageType: pageViewData.PageType,
            productId: pageViewData.ProductId,
            refUri: referrerUri,
            ver: Constants_1.GTL_CLICKSTREAM_PAGEVIEW_PARTB_VER,
            uri: pageImpressionContext.pageUri
        });
    };
    GamingTelemetryProvider.prototype.WritePageAction = function (commonProperties, eventProperties, pageName, behaviorType, pageActionData, pageImpressionId, pageImpressionUri, targetItemId, data) {
        this.providers.Component.WriteWithPartB(commonProperties, eventProperties, data, "PageActionData", {
            behavior: behaviorType,
            content: [
                {
                    cN: pageActionData.ContentDisplayName,
                    contentTags: pageActionData.ContentTags,
                    cS: pageActionData.ContentSource,
                    id: pageActionData.ContentId,
                    parentName: pageActionData.ContentParentName,
                    sN: pageActionData.ContentSlotNumber,
                    targetItemId: targetItemId
                }
            ],
            id: pageImpressionId,
            name: pageName,
            pageType: pageActionData.PageType,
            targetUri: pageActionData.DestinationUri,
            ver: Constants_1.GTL_CLICKSTREAM_PAGEACTION_PARTB_VER,
            uri: pageImpressionUri
        });
    };
    GamingTelemetryProvider.prototype.WriteContentUpdate = function (commonProperties, eventProperties, pageName, pageContentData, pageImpressionId, pageImpressionUri, pageType, data) {
        var commonSchemaContent = pageContentData.map(function (content) {
            return {
                cN: content.ContentDisplayName,
                contentTags: content.ContentTags,
                cS: content.ContentSource,
                id: content.ContentId,
                parentName: content.ContentParentName,
                sN: content.ContentSlotNumber,
                targetItemId: content.TargetItemId
            };
        });
        this.providers.Component.WriteWithPartB(commonProperties, eventProperties, data, "ContentUpdateData", {
            content: commonSchemaContent,
            id: pageImpressionId,
            name: pageName,
            pageType: pageType,
            ver: Constants_1.GTL_CLICKSTREAM_CONTENTUPDATE_PARTB_VER,
            uri: pageImpressionUri
        });
    };
    GamingTelemetryProvider.prototype.WriteAppAction = function (commonProperties, eventProperties, actionName, appActionData, pageImpressionId, pageImpressionUri, data) {
        this.providers.Component.WriteWithPartB(commonProperties, eventProperties, data, "AppActionData", {
            actionName: actionName,
            id: pageImpressionId,
            uri: pageImpressionUri,
            foregroundPageName: appActionData.ForegroundPageName,
            foregroundPageType: appActionData.ForegroundPageType,
            ver: Constants_1.GTL_APPACTION_PARTB_VER
        });
    };
    GamingTelemetryProvider.prototype.WriteAppLaunch = function (commonProperties, eventProperties, launchType, launchData, data) {
        var _a, _b, _c, _d;
        this.providers.Component.WriteWithPartB(commonProperties, eventProperties, data, "AppLaunchData", {
            activationUri: (_a = launchData) === null || _a === void 0 ? void 0 : _a.ActivationUri,
            activationIntent: (_b = launchData) === null || _b === void 0 ? void 0 : _b.ActivationIntent,
            activationPageName: (_c = launchData) === null || _c === void 0 ? void 0 : _c.ActivationPageName,
            activationDuration: (_d = launchData) === null || _d === void 0 ? void 0 : _d.ActivationDuration,
            launchType: launchType,
            ver: Constants_1.GTL_APPLAUNCH_PARTB_VER
        });
    };
    GamingTelemetryProvider.prototype.WriteActiveUserUpdated = function (commonProperties, eventProperties) {
        this.providers.DoublePump.AsCriticalOptional(commonProperties, eventProperties, eventProperties, {});
    };
    GamingTelemetryProvider.prototype.WriteRelatedCv = function (commonProperties, eventProperties, relatedCv) {
        this.providers.Component.WriteWithPartB(commonProperties, eventProperties, {}, "RelatedCv", {
            relatedCv: relatedCv,
            ver: Constants_1.GTL_RELATEDCV_PARTB_VER
        });
    };
    GamingTelemetryProvider.prototype.WriteCustomEvent = function (commonProperties, eventProperties, data) {
        this.providers.Component.Write(commonProperties, eventProperties, data);
    };
    return GamingTelemetryProvider;
}());
exports.GamingTelemetryProvider = GamingTelemetryProvider;
//# sourceMappingURL=GamingTelemetryProvider.js.map